document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('.scrolling-images-container');
  const wrapper = document.querySelector('.scrolling-images-wrapper[data-scrolling-wrapper]');
  const totalItems = parseInt(container.dataset.totalItems) || 1; // Número total de items en la colección (manejar NaN o 0)
  const autoplaySpeed = parseInt(container.dataset.autoplaySpeed) * 1000; // Convertir segundos a milisegundos
  const itemWidth = wrapper.querySelector('.scrolling-image-item')?.offsetWidth || 200; // Ancho de cada item, con fallback
  let intervalId;
  let isTouching = false;
  let touchStartX = 0;
  let touchCurrentX = 0;
  let momentumInterval;
  let isPausedByNavigation = false;

  // Iniciar autoplay con efecto infinito simulado (como respaldo de las animaciones CSS)
  function startAutoplay() {
    clearInterval(intervalId);
    intervalId = setInterval(() => {
      if (!isTouching && !isPausedByNavigation) {
        wrapper.scrollLeft += itemWidth; // Avanza una imagen
        if (wrapper.scrollLeft >= itemWidth * totalItems) { // Reinicia al inicio cuando llegue al final
          wrapper.scrollLeft = 0;
        }
      }
    }, autoplaySpeed);
  }

  // Detener autoplay
  function stopAutoplay() {
    clearInterval(intervalId);
    wrapper.style.animationPlayState = 'paused'; // Pausar animación CSS si está activa
  }

  // Reiniciar autoplay al cargar o recargar la página
  function resetAutoplay() {
    isPausedByNavigation = false;
    isTouching = false;
    stopAutoplay();
    wrapper.scrollLeft = 0; // Reinicia la posición al inicio
    wrapper.style.animationPlayState = 'running'; // Reanuda la animación CSS
    startAutoplay(); // Reanuda el autoplay como respaldo
  }

  // Iniciar autoplay inicialmente
  resetAutoplay();

  // Ajustar el ancho del wrapper dinámicamente para simular infinito
  wrapper.style.width = `${itemWidth * totalItems}px`; // Establecer ancho inicial basado en los items

  // Detectar cambios en la navegación (al volver atrás)
  window.addEventListener('pageshow', (event) => {
    if (event.persisted || (window.performance && window.performance.navigation.type === 2)) {
      // El usuario volvió atrás con el botón del navegador
      resetAutoplay();
    }
  });

  // Eventos de toque para móviles, permitiendo scroll vertical
  wrapper.addEventListener('touchstart', (e) => {
    isTouching = true;
    stopAutoplay();
    touchStartX = e.touches[0].clientX;
    touchCurrentX = touchStartX;
    clearInterval(momentumInterval); // Detener momentum si hay
    wrapper.style.animationPlayState = 'paused'; // Pausar animación CSS
  });

  wrapper.addEventListener('touchmove', (e) => {
    const touchX = e.touches[0].clientX;
    const deltaX = touchX - touchCurrentX;
    const deltaY = e.touches[0].clientY - (wrapper.dataset.startY || 0); // Añadimos deltaY para detectar scroll vertical

    // Solo movemos el scroll horizontal si el movimiento es mayormente horizontal
    if (Math.abs(deltaX) > Math.abs(deltaY)) {
      wrapper.scrollLeft -= deltaX; // Mover el scroll según el deslizamiento horizontal
      e.preventDefault(); // Bloquea solo el scroll horizontal predeterminado
    }
    touchCurrentX = touchX;
    // Guardamos la posición Y inicial para calcular deltaY
    if (!wrapper.dataset.startY) {
      wrapper.dataset.startY = e.touches[0].clientY;
    }
  });

  wrapper.addEventListener('touchend', (e) => {
    isTouching = false;
    const velocity = (touchStartX - touchCurrentX) / 50; // Ajusté a /50 para más sensibilidad
    let currentPosition = wrapper.scrollLeft;

    // Efecto de momentum (continúa moviéndose a la velocidad configurada)
    let momentumSpeed = Math.abs(velocity) * 1000; // Ajusta según necesites
    if (momentumSpeed > 0) {
      momentumInterval = setInterval(() => {
        if (!isTouching) {
          currentPosition += velocity * 5; // Ajusté a *5 para más suavidad
          wrapper.scrollLeft = currentPosition;
          if (Math.abs(velocity) < 0.1 || currentPosition <= 0 || currentPosition >= itemWidth * totalItems) {
            clearInterval(momentumInterval);
            wrapper.style.animationPlayState = 'running'; // Reanudar animación CSS
            startAutoplay(); // Reanudar autoplay después del momentum
          }
        }
      }, 16); // ~60fps para suavidad
    } else {
      wrapper.style.animationPlayState = 'running'; // Reanudar animación CSS
      startAutoplay(); // Reanudar autoplay si no hay momentum
    }
    // Limpiamos la posición Y inicial
    delete wrapper.dataset.startY;
  });

  // Corregir bug de redirección al hacer clic en un producto
  const productLinks = document.querySelectorAll('.product-link');
  productLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault(); // Prevenir comportamiento predeterminado
      const url = link.getAttribute('href');
      if (url) {
        isPausedByNavigation = true; // Indicar que el autoplay debe pausarse temporalmente
        stopAutoplay();
        wrapper.style.animationPlayState = 'paused'; // Pausar animación CSS
        window.location.href = url; // Redirigir al detalle del producto
      }
    });
  });
});